"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fieldset = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _Field = require("./Field");

function getFieldsetSpacingBySize(size) {
  switch (size) {
    case 'small':
      return 0.75;

    case 'medium':
      return 1;

    case 'large':
    default:
      return 1.25;
  }
}

function getFieldsetFieldSpacingBySize(size) {
  switch (size) {
    case 'small':
      return 0.5;

    case 'medium':
      return 0.75;

    case 'large':
    default:
      return 1;
  }
}

const Fieldset = _styledComponents.default.fieldset.withConfig({
  displayName: "Formstyles__Fieldset"
})(["& + &{margin-top:", ";}", " + ", "{margin-top:", ";}"], _ref => {
  let {
    size
  } = _ref;
  return (0, _theme.spacing)(getFieldsetSpacingBySize(size));
}, _Field.FieldStyled, _Field.FieldStyled, _ref2 => {
  let {
    size
  } = _ref2;
  return (0, _theme.spacing)(getFieldsetFieldSpacingBySize(size));
});

exports.Fieldset = Fieldset;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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